import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";
import { ConfigurationServices } from "../services";
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationPage } from '../configuration';
import { Uploads } from '../../services/uploads';
import * as firebase from 'firebase';

/**
 * Generated class for the ConfigurationSecondDisplaImagesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-configuration-second-display-images',
    templateUrl: 'configuration-second-display-images.html',
})
export class ConfigurationSecondDisplaImagesPage {
    public firestore: any;
    selectedFiles: FileList;
    previewImages: string[] = [];
    imageRefs: string[] = []; // URLs de imágenes subidas
    uploadedImages: string[] = [];
    uploadingImages: boolean = false;
    deletingImageIndex: number;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public configurationServices: ConfigurationServices,
        public globals: Globals,
        public translate: TranslateService,
        public uploadServices: Uploads) {
        this.firestore = firebase.firestore();
    }

    async ionViewWillEnter() {
        if (this.globals.restaurant.images_second_display && this.globals.restaurant.images_second_display.length > 0) {
            this.loadUploadedImages();
        }
    }

    async loadUploadedImages() {
        try {
            const imagePromises = this.globals.restaurant.images_second_display.map((imageRef: string) =>
                "https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/" + imageRef.replace('/', '%2F') + "?alt=media"
            );
            this.uploadedImages = imagePromises;
        } catch (error) { }
    }


    selectMultipleFiles(event) {
        this.selectedFiles = event.target.files;
        this.previewImages = [];

        Array.from(this.selectedFiles).forEach((file: File) => {
            if (file.type.match('image.*')) {
                const reader = new FileReader();
                reader.onload = (e: any) => this.previewImages.push(e.target.result);
                reader.readAsDataURL(file);
            } else {
                this.globals.launchToast(this.translate.instant('general-tipo-archivo-no-compatible') + ': ' + file.name, 3000, 'top');
            }
        });
    }

    async uploadMultipleImages() {
        if (!this.selectedFiles || this.selectedFiles.length === 0) {
            this.globals.launchToast(this.translate.instant('general-no-se-han-seleccionado-imagenes'), 3000, 'top');

            return;
        }

        // Verifica el número total de imágenes
        const currentImageCount = this.globals.restaurant.images_second_display ? this.globals.restaurant.images_second_display.length : 0;
        const newImagesCount = this.selectedFiles.length;

        if (currentImageCount + newImagesCount > 8) {
            this.globals.launchToast(this.translate.instant('general-alert-limite-8-imagenes') + " " + currentImageCount + ".", 3000, 'top');
            return;
        }

        try {
            // Mapea los archivos y sube cada uno
            this.uploadingImages = true;
            const uploadPromises = Array.from(this.selectedFiles).map(async (file) => {
                if (!file.type.startsWith('image/')) {
                    this.globals.launchToast(this.translate.instant('general-tipo-archivo-no-compatible') + ': ' + file.name, 3000, 'top');
                    return null; // Salta archivos no válidos
                }
                // Renombra el archivo
                const renamedFiles = this.globals.RenameFiles([file], this.globals.restaurant_uid);
                // Sube el archivo a Firebase
                const ref = await this.uploadServices.uploadFilesComplete(renamedFiles, 'second_display');
                return ref; // Retorna el URL de referencia del archivo
            });
            // Espera a que todas las subidas se completen
            const uploadedRefs = await Promise.all(uploadPromises);
            // Filtra los valores nulos o indefinidos
            const validRefs = uploadedRefs.filter((ref) => ref !== null && ref !== undefined);

            if (validRefs.length > 0) {
                // Actualiza Firestore añadiendo las nuevas imágenes al array existente
                await this.globals.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
                    images_second_display: firebase.firestore.FieldValue.arrayUnion(...validRefs),
                });
                // Actualiza el array localmente también
                if (this.globals.restaurant.images_second_display == undefined) {
                    this.globals.restaurant.images_second_display = [];
                }
                this.globals.restaurant.images_second_display.push(...validRefs);

                this.globals.launchToast(this.translate.instant('general-imagenes-subidas'), 3000, 'top');
            } else {
                this.globals.launchToast(this.translate.instant('general-sin-imagenes-validas'), 3000, 'top');
            }

            // Limpia las previsualizaciones después de subir
            this.uploadingImages = false;
            this.selectedFiles = null;
            this.previewImages = [];
            this.loadUploadedImages();
        } catch (error) {
            // Limpia las previsualizaciones después de subir
            this.uploadingImages = false;
            this.selectedFiles = null;
            this.previewImages = [];
            // Toast error
            this.globals.launchToast(this.translate.instant('general-error-subida'), 3000, 'top');
        }
    }




    goBack() {
        this.globals.side_menu_config_active = '';
        if (this.navCtrl.canGoBack())
            this.navCtrl.pop();
        else
            this.navCtrl.setRoot(ConfigurationPage);
    }


    async deleteImage(imgRef, index) {
        this.deletingImageIndex = index;

        try {
            // Elimina la referencia del array localmente
            const imageToRemove = this.globals.restaurant.images_second_display[index];

            // Opcional: Elimina la imagen del almacenamiento de Firebase
            const storageRef = firebase.storage().ref(imageToRemove);
            await storageRef.delete();

            // Actualiza el array eliminando el índice correspondiente
            this.globals.restaurant.images_second_display.splice(index, 1);

            // Refleja este cambio en Firestore
            await this.globals.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
                images_second_display: this.globals.restaurant.images_second_display,
            });

            // Actualiza las imágenes mostradas en la UI
            this.uploadedImages.splice(index, 1);
            this.loadUploadedImages();
            this.deletingImageIndex = null;
            this.globals.launchToast(this.translate.instant('general-imagen-eliminada-exito'), 3000, 'top');
        } catch (error) {
            this.deletingImageIndex = null;
            this.globals.launchToast(this.translate.instant('general-error-eliminar-imagen'), 3000, 'top');
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-second-display-images/configuration-second-display-images.ts